import { useQuery } from '@tanstack/react-query';
import useGlynt from '../hooks/useGlynt';
import { useContext } from 'react';
import { AppContext } from '../../App';
import { useLocation } from 'react-router';
import type { MatDiscoveryResponse } from '../../types/mat-types';
import { discoveryEntryParams, type DiscoveryPosition } from './matDiscoveryTableHelpers';
import type { DiscoveredDataSourceStatus } from '../../types/mat-types';

interface UseMatDiscoveryArgs {
  has_existing_mat?: string;
  data_verified?: string;
  position?: DiscoveryPosition;
}

const useMatDiscovery = ({
  has_existing_mat,
  data_verified,
  position = { index: 0 },
}: UseMatDiscoveryArgs) => {
  const glynt = useGlynt();
  const { dataPoolId } = useContext(AppContext);

  return useQuery({
    queryKey: ['mat-discovery', dataPoolId, has_existing_mat, data_verified, position],

    queryFn: async () => {
      const g = await glynt;
      const params: Record<string, any> = {
        ...(has_existing_mat ? { has_existing_mat } : {}),
        ...(data_verified ? { data_verified } : {}),
        ...discoveryEntryParams(position),
      };
      return (await g.mat.matDiscovery(params)) as MatDiscoveryResponse;
    },

    // keep in sync when switching tabs/routes within same dpid
    staleTime: 30_000
  });
};

export default useMatDiscovery;
